import {
  TextField,
  InputAdornment,
  MenuItem,
  Box,
  Chip,
  Button,
} from "@mui/material";
import currency from "currency.js";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import { CONTRACT_STATUS } from "../../constants";
import { getContractField, exportContractsToCSV } from "../../functions";

// El filtro "Año" es el de creación del contrato (createdAt en GET_CONTRACTS):
// desde el primero con contratos en la plataforma hasta el año en curso, para
// que cada enero el año nuevo aparezca sin tocar el código.
const FIRST_CREATION_YEAR = 2024;
const CREATION_YEARS = Array.from(
  { length: new Date().getFullYear() + 1 - FIRST_CREATION_YEAR },
  (_, i) => FIRST_CREATION_YEAR + i
);

const STATUS_LABELS = {
  [CONTRACT_STATUS.DRAFT]: 'Borrador',
  [CONTRACT_STATUS.SUPERVISOR]: 'Revisión por supervisor',
  [CONTRACT_STATUS.APPROVED]: 'Aprobado por supervisor',
  [CONTRACT_STATUS.SUSPENDED]: 'Suspendido',
  [CONTRACT_STATUS.FINISHED]: 'Finalizado',
  [CONTRACT_STATUS.CLOSED]: 'Cerrado',
};

const FinancingFilters = ({
  searchTerm,
  handleSearchChange,
  statusFilter,
  handleStatusFilterChange,
  filteredContracts,
  contracts,
  selectedYear,
  setSelectedYear,
  natureFilter,
  handleNatureFilterChange,
  natureOptions,
}) => {
  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        <TextField
          fullWidth
          placeholder="Buscar por código, objeto, contratista, supervisor o cédula..."
          value={searchTerm}
          onChange={(e) => handleSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          select
          fullWidth
          label="Estado"
          value={statusFilter}
          onChange={(e) => handleStatusFilterChange(e.target.value)}
        >
          <MenuItem value="ALL">Todos los estados</MenuItem>
          {Object.values(CONTRACT_STATUS).map((status) => (
            <MenuItem key={status} value={status}>
              {STATUS_LABELS[status] || status}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          fullWidth
          label="Naturaleza / Convenio"
          value={natureFilter}
          onChange={(e) => handleNatureFilterChange(e.target.value)}
        >
          <MenuItem value="ALL">Todas las naturalezas</MenuItem>
          {natureOptions.map((nature) => (
            <MenuItem key={nature} value={nature}>
              {nature}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="Año"
          value={selectedYear}
          onChange={e => setSelectedYear(Number(e.target.value))}
          sx={{ minWidth: 120 }}
        >
          {CREATION_YEARS.map((year) => (
            <MenuItem key={year} value={year}>{year}</MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Summary */}
      <Box
        sx={{ mb: 2, display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}
      >
        <Chip label={`Total: ${filteredContracts.length}`} color="primary" />
        <Chip
          label={`Valor Total: ${currency(
            filteredContracts.reduce((sum, c) => {
              const getField = getContractField(c.news || [], c);
              return sum + (getField("contractBudget") || 0);
            }, 0)
          ).format()}`}
          color="success"
        />
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={() => exportContractsToCSV(filteredContracts)}
          size="small"
          sx={{ ml: "auto" }}
        >
          Descargar CSV
        </Button>
      </Box>
    </>
  );
};

export default FinancingFilters;
